import { StaffMember } from '../models/staff-member.model';

export const STAFF_MEMBERS: StaffMember[] = [
  {
    name: 'Dr. Amira Nasri',
    role: 'Mathematics Teacher',
    bio: 'Mathematics professor with 12+ years of experience helping students excel in algebra, calculus, and advanced mathematics.',
    specialties: ['Algebra', 'Calculus', 'Problem Solving']
  },
  {
    name: 'Prof. Karim Jebali',
    role: 'Physics Teacher',
    bio: 'Physics educator passionate about making complex scientific concepts accessible and engaging for all students.',
    specialties: ['Classical Physics', 'Modern Physics', 'Laboratory Work']
  },
  {
    name: 'Ms. Lina Trabelsi',
    role: 'Languages Teacher',
    bio: 'Multilingual educator specializing in French, English, and Arabic literature, fostering communication skills and cultural understanding.',
    specialties: ['French Literature', 'English Grammar', 'Arabic Poetry']
  },
  {
    name: 'Dr. Youssef Hamdi',
    role: 'Science Teacher',
    bio: 'Biology and chemistry teacher with expertise in life sciences, helping students understand the natural world through hands-on learning.',
    specialties: ['Biology', 'Chemistry', 'Environmental Science']
  }
];
